module.exports = __webpack_public_path__ + "27fb08ef010352224785d336effd85dd.pdf";